module.exports = __webpack_public_path__ + "static/uge-b09aea7211efcbbd649dfc003fa544d3.jpg";